module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/download-3c3702cb6ffc33119a38886546f4e8b7.svg";